import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import 'bootstrap/dist/css/bootstrap.css';
import './scss/styles.scss';

Sentry.init({
  dsn: "https://d24b60a787c6cc36754812dfb5e1ecae@o135301.ingest.us.sentry.io/4508934524960768",
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // tracePropagationTargets: [
  //   'localhost', // Local development
  //   'vm-app.gritus.tech', // Server domain
  //   process.env.REACT_APP_SHOPIFY_ADMIN_API_PROXY_URI, // Admin API
  //   process.env.REACT_APP_ZPAY_BASE_URL, // ZPay API'
  //   'localhost:4000'
  // ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
